import { ReactComponent as BigCloseIcon } from 'assets/images/big_close.svg';
import { ReactComponent as MessageIcon } from 'assets/images/message.svg';
import { AiOutlineSearch } from 'react-icons/ai';
import {
  StyledMessageButton,
  StyledIcon,
  StyledContentWrapper,
  StyledContent,
  ContentTitle,
  ContentRow,
  CloseIcon,
  SearchInput,
  ContentHeader,
  ContentBody,
  Title,
  Description,
  ShowButton,
  MessageRow,
  MessageDate,
  SearchInputWrapper,
  SearchInputIcon,
} from './styled';
import { useCallback, useEffect, useState } from 'react';
import { Divider } from 'components/atoms/styleds';
import { StyledFlexbox } from 'components/atoms/Flexbox/styled';
import { useDynamicApi } from 'hooks/api/dynamic-api';
import MessagesApi from 'libs/api/messages';
import { PrimaryModal } from 'components/molecules/Modal';
import { MessagesContent } from 'components/molecules/orders/List/modal';
import MessageDialogApi from 'libs/api/message_dialog';
import { useUser } from 'redux/user/use-user';
import UIHelper from 'services/UIHelper';
import moment from 'moment';

const MessageItem = ({ onOpenDialog, item = {} }) => {
  const yesterday = moment().subtract(1, 'days').startOf('day');
  const dateSend = moment(item.date_send?.date_send || item.created_at);
  const isYesterday = moment(dateSend).isSame(yesterday, 'd');
  const formatSendDate = dateSend.format('dddd. DD MMMM');

  return (
    <MessageRow>
      <MessageDate>{isYesterday ? 'Ieri' : formatSendDate}</MessageDate>
      <Divider mt={20} mb={10} mobileMt={20} mobileMb={10} />
      <StyledFlexbox justify='space-between' align='center'>
        <StyledFlexbox>
          <Title>{dateSend.format('HH:mm')}</Title>
          <Title style={{ marginLeft: 20 }}>{item.subject}</Title>
        </StyledFlexbox>
        <ShowButton onClick={onOpenDialog}>Apri conversazione</ShowButton>
      </StyledFlexbox>
      <Description>{item.last_message?.message}</Description>
      <Divider mt={10} mb={0} mobileMt={10} mobileMb={0} />
    </MessageRow>
  );
};

const Messages = () => {
  const { userData } = useUser();
  const [show, setShow] = useState(false);
  const { api: messageApi } = useDynamicApi(MessagesApi);
  const { api: dialogApi } = useDynamicApi(MessageDialogApi);
  const [dialogs, setDialogs] = useState([]);
  const [selectedDialog, setSelectedDialog] = useState({});
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [queryParams, setQueryParams] = useState({
    search: '',
  });
  const [newMessage, setNewMessage] = useState('');
  const [showDialog, setShowDialog] = useState(false);
  const [inProcess, setInProcess] = useState(false);

  useEffect(() => {
    const body = document.querySelector('body');
    if (!body) {
      return;
    }
    if (show) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = 'auto';
    }
  }, [show]);

  useEffect(() => {
    if (show) {
      (async () => {
        const params = {};
        if (queryParams.search) {
          params.search = queryParams.search;
        }
        const { data } = await dialogApi.list({
          params,
        });
        setDialogs(data.message_dialogs);
      })();
    }
  }, [show, queryParams, dialogApi, messageApi]);

  const disableCancelAction = false;

  const onChange = useCallback((e) => {
    const {
      target: { value },
    } = e;
    setNewMessage(value);
  }, []);

  useEffect(() => {}, []);

  const onClickOpenMessageDialog = useCallback(
    async (item) => {
      setInProcess(true);
      try {
        const { data } = await messageApi.list({
          params: {
            message_dialog_id: item.id,
          },
        });
        setSelectedMessages(data.messages);
        setSelectedDialog(item);
        setShowDialog(true);
        setInProcess(false);
        setShow(false);
      } catch (e) {}
    },
    [messageApi],
  );

  const onSubmit = useCallback(async () => {
    try {
      setInProcess(true);
      await messageApi.create({
        data: {
          author_id: userData.id,
          message_dialog_id: selectedDialog.id || null,
          message: newMessage,
          message_type: 'outbox',
          date_send: new Date(),
          targetable_type: selectedDialog.targetable_type,
          targetable_id: selectedDialog.targetable_id,
        },
      });
      const { data } = await messageApi.list({
        params: {
          message_dialog_id: selectedDialog.id,
        },
      });
      setSelectedMessages(data.messages);
      setNewMessage('');
      UIHelper.showSuccessMessage();
    } catch (e) {
      console.log(e);
    } finally {
      setInProcess(false);
    }
  }, [selectedDialog, newMessage]);

  const onClose = useCallback(() => {
    setShowDialog(false);
    setNewMessage('');
  }, []);

  const onChangeSearch = useCallback((e) => {
    const {
      target: { value },
    } = e;
    setQueryParams({
      search: value,
    });
  }, []);

  useEffect(() => {
    const body = document.querySelector('body');
    if (show) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = 'auto';
    }

    return () => {
      body.style.overflow = 'auto';
    };
  }, [show]);

  return (
    <>
      <StyledMessageButton onClick={() => setShow(true)}>
        Vedi messaggi
        <StyledIcon as={MessageIcon} />
      </StyledMessageButton>
      {show && (
        <StyledContentWrapper>
          <StyledContent>
            <ContentHeader>
              <ContentRow mobilePadding='20px 20px 10px 20px'>
                <ContentTitle>Tutti i messaggi</ContentTitle>
                <CloseIcon onClick={() => setShow(false)} as={BigCloseIcon} />
              </ContentRow>
              <Divider mt={12} mb={20} />
              <ContentRow>
                <SearchInputWrapper>
                  <SearchInputIcon color='#FF7828' as={AiOutlineSearch} />
                  <SearchInput
                    type='text'
                    onChange={onChangeSearch}
                    placeholder='Cerca'
                  />
                </SearchInputWrapper>
              </ContentRow>
              <Divider
                style={{
                  boxShadow: ' 0 2px 4px 0 rgba(0, 0, 0, 0.4)',
                  border: 'solid 1px #FF7828',
                }}
                mt={20}
              />
            </ContentHeader>
            <ContentBody className='ristora-scroll'>
              {dialogs?.map((i, index) => (
                <MessageItem
                  key={index.toString()}
                  onOpenDialog={() => onClickOpenMessageDialog(i)}
                  item={i}
                />
              ))}
            </ContentBody>
          </StyledContent>
        </StyledContentWrapper>
      )}
      <PrimaryModal
        onSubmit={onSubmit}
        onClose={onClose}
        onCancel={onClose}
        open={showDialog}
        actionButtonText='Invia'
        cancelButtonText='Annulla'
        variant='config'
        desktopW={740}
        desktopMinH={'50vh'}
        desktopMaxH={'60vh'}
        buttonColor='action'
        title='Conversazione'
        showDivider={true}
        inProcess={inProcess}
        primaryHeader={true}
        disabled={false}
        showFooterDivider={true}
        disabledCancel={disableCancelAction}
      >
        <MessagesContent
          onChange={onChange}
          messages={selectedMessages}
          message={newMessage}
          showInput={true}
        />
      </PrimaryModal>
    </>
  );
};

export default Messages;
